import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AxsIconComponent } from '@vanguard/axs-angular';

@Component({
  selector: 'service-interruption-banner-v4',
  standalone: true,
  imports: [AxsIconComponent],
  templateUrl: './service-interruption-banner.component.html',
  styleUrls: ['./service-interruption-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ServiceInterruptionBannerV4Component {
  @Input() message: string = '';
}
